"use client";

import { useQuery } from "@tanstack/react-query";
import {
	fetchCurrentProfileHandle,
	type HandleFeature,
	type ProfileHandleBinding,
} from "@/lib/api/handle-client";

export const PROFILE_HANDLE_QUERY_KEY = "brc169-profile-handle";

/**
 * The profile's current BRC-169 handle allocation, shared by the site
 * navigation and the account prompt so both cost one request.
 *
 * The answer also carries this deployment's feature decision: every handle
 * endpoint answers RFC 9457 `NOT_FOUND` while the allocation flag is off, and
 * `enabled: false` is what hides the navigation entry rather than showing a
 * link to a feature that does not exist here.
 *
 * It never touches the wallet, so it cannot say a certificate is held — only
 * that an allocation exists. The handle page does the section 5.8 check.
 */
export function useProfileHandle(bapId: string | null) {
	return useQuery<HandleFeature<ProfileHandleBinding | null>>({
		enabled: bapId !== null,
		queryFn: () => fetchCurrentProfileHandle(bapId as string),
		queryKey: [PROFILE_HANDLE_QUERY_KEY, bapId],
		retry: false,
		staleTime: 60_000,
	});
}
